import React, {memo} from 'react';
import {ShopStackParams} from '../types/nav';
import Folderpage from '../components/folder/folderpage';
import {FolderType} from '../types';
import {ShopProduct} from '../components/shop/product';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {WebEditor} from '../components/shop/webeditor';
import {ShopConfig} from '../components/shop/config';
import {OrdersPage} from '../components/shop/orders';
import OrderPage, {OrderParams} from '../components/shop/order';
import {Payouts} from '../components/shop/payout';
import {ShopsList} from '../components/shop/shops';
import {useRoute} from '@react-navigation/native';
import {useFolders} from '../hooks/useFolders';
import FolderLibrary from '../components/folder/folderlibrary';

const ShopStack = createNativeStackNavigator<ShopStackParams>();
const SingleShopStack = createNativeStackNavigator<ShopStackParams>();
const folderType = FolderType.shop;
const FolderComponent = (props: {
  mnemonic: string;
  parentFolderId: string;
  folderId?: string;
}) => (
  <Folderpage
    folderType={folderType}
    mnemonic={props.mnemonic}
    parentFolderId={props.parentFolderId}
    folderId={props.folderId}
  />
);

const SingleShop = () => {
  const params = useRoute().params;
  const {mnemonic, shopId} = params as {
    mnemonic: string;
    shopId: string;
  };
  return (
    <SingleShopStack.Navigator>
      <SingleShopStack.Screen
        name="Categories"
        options={{orientation: 'portrait'}}
        component={() => (
          <FolderComponent
            mnemonic={mnemonic}
            parentFolderId={shopId}
            folderId={shopId}
          />
        )}
      />
      <SingleShopStack.Screen
        name="Product"
        options={{orientation: 'all'}}
        component={ShopProduct}
      />
      <SingleShopStack.Screen
        name="Folder"
        options={{orientation: 'portrait'}}
        component={() => (
          <FolderComponent
            mnemonic={mnemonic}
            parentFolderId={shopId}
          />
        )}
      />
      <SingleShopStack.Screen
        name="WebEditor"
        options={{orientation: 'portrait'}}
        component={WebEditor}
      />
      <SingleShopStack.Screen
        name="ShopConfig"
        options={{orientation: 'portrait'}}
        component={() => (
          <ShopConfig shopId={shopId} mnemonic={mnemonic} />
        )}
      />
      <SingleShopStack.Screen
        name="Orders"
        options={{orientation: 'portrait'}}
        component={() => (
          <OrdersPage shopId={shopId} mnemonic={mnemonic} />
        )}
      />
      <SingleShopStack.Screen
        name="Order"
        options={{orientation: 'portrait'}}
        component={() => (
          <OrderPage shopId={shopId} mnemonic={mnemonic} />
        )}
      />
      <SingleShopStack.Screen
        name="Payouts"
        options={{orientation: 'portrait'}}
        component={() => (
          <Payouts shopId={shopId} mnemonic={mnemonic} />
        )}
      />
    </SingleShopStack.Navigator>
  );
};
export const createShopStack = () => {
  const ShopStackScreen = () => {
    return (
      <ShopStack.Navigator
        screenOptions={{
          headerShown: false,
          freezeOnBlur: true,
        }}>
        <ShopStack.Screen
          name="Shops"
          options={{orientation: 'portrait'}}
          component={ShopsList}
        />
        <ShopStack.Screen
          name="Shop"
          options={{orientation: 'portrait'}}
          component={SingleShop}
        />
      </ShopStack.Navigator>
    );
  };
  return ShopStackScreen;
};
